// src/components/ThemeToggle.js
import React from 'react';
import { useTheme } from '../context/ThemeContext';
import './ThemeToggle.css';

const ThemeToggle = ({ className = '', inMobileMenu = false }) => {
  const { theme, toggleTheme, isDark } = useTheme();

  const containerClass = inMobileMenu 
    ? 'mobile-theme-toggle' 
    : 'theme-toggle-container';

  return (
    <div className={`${containerClass} ${className}`}>
      <button 
        className={`theme-toggle-btn ${theme}`}
        onClick={toggleTheme}
        aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
        title={`Switch to ${isDark ? 'light' : 'dark'} mode`}
      >
        <span className="toggle-emoji">
          {isDark ? '🌙' : '☀️'}
        </span>
      </button>
    </div>
  );
};

export default ThemeToggle;